import PropTypes from 'prop-types';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import { Map as ImmutableMap } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
const Alerts = ({
  activeAlerts,
  onClearAlert
}) => {
  if (activeAlerts.size) {
    return /*#__PURE__*/_jsx(UIFloatingAlertList, {
      alerts: activeAlerts.toList().toJS(),
      onAlertClose: (evt, {
        id
      }) => onClearAlert(id)
    });
  }
  return null;
};
Alerts.propTypes = {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
  activeAlerts: PropTypes.instanceOf(ImmutableMap).isRequired,
  onClearAlert: PropTypes.func.isRequired
};
export default Alerts;